import { render, staticRenderFns } from "./PersonQuestionnaire.vue?vue&type=template&id=6cbfaa95&scoped=true&"
import script from "./PersonQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./PersonQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfaa95",
  null
  
)

export default component.exports